import Header from '@/components/Header';
import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { Link } from 'react-router-dom';
import { CheckCheck } from 'lucide-react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

export default function Notifications() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get('/notifications?limit=200');
    setList(data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const markAll = async () => {
    await api.post('/notifications/read-all');
    load();
  };

  const unread = list.filter((n) => !n.read).length;

  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-3xl mx-auto px-4 md:px-6 py-8">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h1 className="font-display font-black text-3xl md:text-4xl">Notifications</h1>
            <p className="text-zinc-600 mt-1">{unread} unread · {list.length} total</p>
          </div>
          {unread > 0 && <button onClick={markAll} className="btn btn-ghost" data-testid="notif-mark-all"><CheckCheck className="w-4 h-4" /> Mark all read</button>}
        </div>

        {loading ? <div className="card">Loading…</div> : list.length === 0 ? (
          <div className="card text-center py-16">
            <p className="text-zinc-500">No notifications yet. When alerts match your threshold and highway subscriptions, they'll show up here.</p>
          </div>
        ) : (
          <div className="space-y-2">
            {list.map((n) => (
              <Link key={n.id} to={n.alert_id ? `/alerts/${n.alert_id}` : '#'} className={`card block ${!n.read ? 'bg-teal-50/50 border-teal-200' : ''}`} data-testid={`notif-${n.id}`}>
                <div className="flex items-start gap-3">
                  <div className={`w-2.5 h-2.5 rounded-full mt-2 flex-shrink-0 ${n.severity === 'red' ? 'bg-red-600' : n.severity === 'orange' ? 'bg-orange-500' : 'bg-yellow-400'}`} />
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold">{n.title}</div>
                    <div className="text-sm text-zinc-600 mt-0.5">{n.body}</div>
                    <div className="text-xs text-zinc-400 mt-1">{dayjs(n.created_at).fromNow()}</div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
